module.exports = __webpack_public_path__ + "static/media/icon-edital-erro.cb44a88f.svg";